import { first, tap, map } from 'rxjs';
import { Component, SkipSelf } from '@angular/core';
import {
  ItemView,
  ItemViewProviderDirective,
  NotificationService,
  Util,
  NtapGlobalConstants,
  ListViewProviderDirective,
  ListView,
  DEFAULT_ITEM_VIEW
} from '@ntap/core';
import { DynamicFormService } from '@ntap/common';

@Component({
  selector: 'app-izvjestaj-itemview',
  template: ` <p-panel>
    <p-header class="bigger-bold-text">{{ viewTitle }}</p-header>
    <ng-container>
      <ntap-dynamic [compId]="itemCompId"></ntap-dynamic>
      <p-footer>
        <p-toolbar>
          <div class="container">
            <app-generiraj-izvjestaj-action
              class="right-button"
              [format]="'pdf'"
            ></app-generiraj-izvjestaj-action>
            <app-generiraj-izvjestaj-action
              class="right-button"
            ></app-generiraj-izvjestaj-action>
          </div>
        </p-toolbar>
      </p-footer>
    </ng-container>
  </p-panel>`,
  providers: [ItemViewProviderDirective<ItemView>],
  styleUrls: ['./izvjestaj-item-view.component.scss']
})
export class AppIzvjestajItemViewComponent {
  public item: any;
  public readonly itemCompId = 'izvjestaj_item_view';
  public viewTitle = 'Izrada izvještaja';

  constructor(
    protected notificationService: NotificationService,
    protected dynamicFormService: DynamicFormService,
    @SkipSelf() protected itemViewProvider: ItemViewProviderDirective<ItemView>,
    protected generirajIzvjestajItemViewProvider: ItemViewProviderDirective<ItemView>,
    protected listViewProviderDirective: ListViewProviderDirective<ListView>
  ) {
    this.itemViewProvider.item$
      .pipe(
        first(),
        tap((item) => {
          const nazivTipaAttribute: string = Util.getFullAttrName(
            'pis~izvjestaj',
            'naziv_tipa'
          );
          let openTypeName = (item as any)[nazivTipaAttribute];
          openTypeName = openTypeName.replace('.', '~');

          const viewState: { [key: string]: string } = {};

          viewState[NtapGlobalConstants.ATTR_$itemType] = openTypeName;
          viewState[NtapGlobalConstants.ATTR_$mainType] = openTypeName;
          viewState[
            Util.getFullAttrName('pis~izvjestaj', NtapGlobalConstants.ATTR_id)
          ] = (item as any)[
            Util.getFullAttrName('pis~izvjestaj', NtapGlobalConstants.ATTR_id)
          ];
          viewState[
            Util.getFullAttrName(openTypeName, NtapGlobalConstants.ATTR_id)
          ] = '0';
          this.generirajIzvjestajItemViewProvider.viewName = DEFAULT_ITEM_VIEW;
          this.generirajIzvjestajItemViewProvider.viewState = viewState;
        })
      )
      .subscribe();

    this.generirajIzvjestajItemViewProvider.view$
      .pipe(
        first(),
        map((item) => {
          item.actions.splice(0, item.actions.length);
          return item;
        })
      )
      .subscribe();
  }
}
